import React from 'react';
import { InventoryStockBalanceSummaryCounts } from '@/renderer/types/inventory';
import { formatReportMoney } from '@/renderer/util/reporting';

export function StockBalancesSummaryCards({
  summary,
}: {
  summary: InventoryStockBalanceSummaryCounts;
}) {
  const cards = [
    { label: 'Balance rows', value: summary.totalBalanceRows.toLocaleString() },
    {
      label: 'Quantity on hand',
      value: summary.totalQuantityOnHand.toLocaleString(undefined, {
        maximumFractionDigits: 2,
      }),
    },
    {
      label: 'Stock value',
      value: formatReportMoney(summary.totalStockValue),
    },
    { label: 'Low stock items', value: summary.lowStockItems.toLocaleString() },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-sm"
        >
          <p className="text-sm text-gray-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-gray-900">
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
}
